import React from 'react'

type IconProps = {
    color?: string
    width?: string
    height?: string
}

const HomeIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7148 2.30047L20.4238 10.1845C20.7898 10.5605 20.9998 11.0845 20.9998 11.6235V19.9995C20.9998 21.1025 20.1528 21.9995 19.1118 21.9995H15.9998V12.9995C15.9998 12.4475 15.5528 11.9995 14.9998 11.9995H8.99976C8.44676 11.9995 7.99976 12.4475 7.99976 12.9995V21.9995H4.88876C3.84776 21.9995 2.99976 21.1025 2.99976 19.9995V11.6235C2.99976 11.0845 3.20976 10.5605 3.57476 10.1855L11.2848 2.30047C11.6618 1.91547 12.3378 1.91547 12.7148 2.30047ZM14 21H10V14H14V21Z"
            fill="#231F20"
        />
        <mask
            id="mask0_18862_101"
            maskUnits="userSpaceOnUse"
            x="2"
            y="2"
            width="19"
            height="20"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7148 2.30047L20.4238 10.1845C20.7898 10.5605 20.9998 11.0845 20.9998 11.6235V19.9995C20.9998 21.1025 20.1528 21.9995 19.1118 21.9995H15.9998V12.9995C15.9998 12.4475 15.5528 11.9995 14.9998 11.9995H8.99976C8.44676 11.9995 7.99976 12.4475 7.99976 12.9995V21.9995H4.88876C3.84776 21.9995 2.99976 21.1025 2.99976 19.9995V11.6235C2.99976 11.0845 3.20976 10.5605 3.57476 10.1855L11.2848 2.30047C11.6618 1.91547 12.3378 1.91547 12.7148 2.30047ZM14 21H10V14H14V21Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_18862_101)">
            <rect width="24" height="24" fill="#636363" />
        </g>
    </svg>
)

export const VillageIcon = ({
    color = '#636363',
    width = '24',
    height = '24'
}: IconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.30769 7.38457C8.30769 9.42088 9.96369 11.0769 12 11.0769C14.0363 11.0769 15.6923 9.42088 15.6923 7.38457C15.6923 5.34826 14.0363 3.69226 12 3.69226C9.96369 3.69226 8.30769 5.34826 8.30769 7.38457Z"
            fill={color}
        />
        <path
            d="M1.84615 10.1538C1.84615 11.6806 3.08862 12.923 4.61538 12.923C6.14215 12.923 7.38462 11.6806 7.38462 10.1538C7.38462 8.62703 6.14215 7.38457 4.61538 7.38457C3.08862 7.38457 1.84615 8.62703 1.84615 10.1538Z"
            fill={color}
        />
        <path
            d="M0.923077 19.3846C0.412616 19.3846 0 18.971 0 18.4615C0 15.9166 2.07046 13.8461 4.61538 13.8461C5.65002 13.8461 6.63758 14.1912 7.43968 14.8114C8.46304 13.7909 9.82568 13.1106 11.3413 12.9564C11.5579 12.9343 11.7777 12.923 12 12.923C12.227 12.923 12.4514 12.9348 12.6724 12.9578C14.1826 13.1147 15.5401 13.794 16.5603 14.8114C17.3624 14.1912 18.35 13.8461 19.3846 13.8461C21.9295 13.8461 24 15.9166 24 18.4615C24 18.971 23.5874 19.3846 23.0769 19.3846H18.4615C18.4615 19.8941 18.0489 20.3076 17.5385 20.3076H6.46154C5.95108 20.3076 5.53846 19.8941 5.53846 19.3846H0.923077Z"
            fill={color}
        />
        <path
            d="M22.1538 10.1538C22.1538 11.6806 20.9114 12.923 19.3846 12.923C17.8578 12.923 16.6154 11.6806 16.6154 10.1538C16.6154 8.62703 17.8578 7.38457 19.3846 7.38457C20.9114 7.38457 22.1538 8.62703 22.1538 10.1538Z"
            fill={color}
        />
    </svg>
)

const VillagesIcon = ({
    color = '#636363',
    width = '25',
    height = '24'
}: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none">
        <path
            d="M8.52491 10.5517C8.48943 10.5517 8.45425 10.5585 8.42146 10.572C3.76546 12.4986 1.17612 19.3858 0.903284 22.6787C0.890316 22.8352 1.01604 22.9655 1.17309 22.9655H5.79886C5.96995 22.9655 6.09968 22.8122 6.08003 22.6422C5.67562 19.1447 8.025 13.5758 10.8349 11.341C11.0769 11.1486 10.9238 10.5517 10.6146 10.5517H8.52491Z"
            fill={color}
        />
        <path
            d="M14.4537 10.5517C14.4197 10.5517 14.3861 10.5578 14.3544 10.5704C10.2073 12.2165 7.36833 18.659 6.97835 22.6724C6.9629 22.8315 7.08966 22.9655 7.24949 22.9655H11.8718C12.0416 22.9655 12.1709 22.8139 12.1524 22.6452C11.8056 19.483 13.3069 13.6673 16.8325 11.2796C17.0893 11.1057 16.964 10.5517 16.6538 10.5517H14.4537Z"
            fill={color}
        />
        <path
            d="M20.5326 10.5517C20.4922 10.5517 20.4521 10.5605 20.4156 10.5779C16.1115 12.6268 13.3958 17.5678 13.3013 22.6895C13.2985 22.8418 13.4223 22.9655 13.5746 22.9655H17.9427C18.1118 22.9655 18.241 22.8153 18.2224 22.6472C17.8572 19.3363 19.3156 13.6565 23.0647 11.2125C23.3191 11.0467 23.2046 10.5517 22.9008 10.5517H20.5326Z"
            fill={color}
        />
        <path
            d="M1.85049 10.5517C1.17437 10.5517 0.49825 11.2145 0.342004 11.7604C0.335797 11.7821 0.333252 11.8045 0.333252 11.827V18.9655C0.571983 17.0557 2.56667 13.08 4.97654 11.2397C5.21495 11.0576 5.08237 10.5517 4.78238 10.5517H1.85049Z"
            fill={color}
        />
        <path
            d="M23.948 12.4031C24.1242 12.3051 24.3333 12.4375 24.3333 12.6391V21.8234C24.3333 21.849 24.3298 21.8741 24.3218 21.8984C24.2643 22.0729 23.9856 22.821 23.3946 22.9596C23.3769 22.9638 23.3586 22.9655 23.3404 22.9655H19.5057C19.3533 22.9655 19.2295 22.8427 19.2326 22.6904C19.2969 19.4673 20.4883 14.3264 23.948 12.4031Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0767 4.59625C19.9824 4.52813 19.8554 4.52651 19.7594 4.59222L17.4189 6.19364C17.3437 6.24506 17.2988 6.33025 17.2988 6.42131V9.44822C17.2988 9.60057 17.4223 9.72408 17.5746 9.72408H22.1264C22.2787 9.72408 22.4022 9.60057 22.4022 9.44822V6.41686C22.4022 6.32828 22.3597 6.24508 22.2879 6.19322L20.0767 4.59625ZM20.7471 6.82753C20.7471 6.67517 20.6236 6.55167 20.4712 6.55167H19.2298C19.0775 6.55167 18.954 6.67517 18.954 6.82753V8.06891C18.954 8.22126 19.0775 8.34477 19.2298 8.34477H20.4712C20.6236 8.34477 20.7471 8.22126 20.7471 8.06891V6.82753Z"
            fill={color}
        />
        <path
            d="M12.6251 2.79027C12.5319 2.72931 12.4112 2.7304 12.3191 2.79304L9.14365 4.95232C9.06812 5.00368 9.02291 5.0891 9.02291 5.18044V9.44822C9.02291 9.60057 9.14641 9.72408 9.29877 9.72408H11.3677C11.5201 9.72408 11.6436 9.60057 11.6436 9.44822V6.82753C11.6436 6.67517 11.7671 6.55167 11.9195 6.55167H13.0229C13.1753 6.55167 13.2988 6.67517 13.2988 6.82753V9.44822C13.2988 9.60057 13.4223 9.72408 13.5746 9.72408H15.7815C15.9339 9.72408 16.0574 9.60057 16.0574 9.44822V5.18365C16.0574 5.09054 16.0104 5.00372 15.9325 4.95276L12.6251 2.79027Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32235 4.59935C5.22593 4.52971 5.09574 4.52971 4.99932 4.59935L2.79243 6.19322C2.72062 6.24508 2.67808 6.32828 2.67808 6.41686V9.44822C2.67808 9.60057 2.80159 9.72408 2.95394 9.72408H7.36773C7.52009 9.72408 7.6436 9.60057 7.6436 9.44822V6.41686C7.6436 6.32828 7.60106 6.24508 7.52925 6.19322L5.32235 4.59935ZM6.12636 6.82753C6.12636 6.67517 6.00285 6.55167 5.85049 6.55167H4.60912C4.45677 6.55167 4.33326 6.67517 4.33326 6.82753V8.06891C4.33326 8.22126 4.45677 8.34477 4.60912 8.34477H5.85049C6.00285 8.34477 6.12636 8.22126 6.12636 8.06891V6.82753Z"
            fill={color}
        />
        <path
            d="M2.12636 4.90436C2.12636 4.81314 2.17145 4.72782 2.24681 4.67643L5.00176 2.79806C5.09733 2.7329 5.22339 2.73428 5.31751 2.8015L7.94187 4.67605C8.01437 4.72783 8.05739 4.81144 8.05739 4.90053V5.18803C8.05739 5.41241 7.80377 5.54292 7.62119 5.41251L5.31751 3.76702C5.22339 3.69979 5.09733 3.69842 5.00176 3.76357L2.55762 5.43004C2.3745 5.55489 2.12636 5.42374 2.12636 5.20211V4.90436Z"
            fill={color}
        />
        <path
            d="M8.74704 3.79831C8.74704 3.70853 8.79073 3.62437 8.86415 3.57271L12.3153 1.14413C12.4091 1.07811 12.534 1.07705 12.6289 1.14147L16.2123 3.57303C16.2879 3.62437 16.3333 3.70987 16.3333 3.8013V3.97741C16.3333 4.19567 16.0918 4.32748 15.9082 4.20946L12.6231 2.09761C12.5308 2.03829 12.4122 2.03928 12.3209 2.10012L9.17593 4.19678C8.9926 4.319 8.74704 4.18758 8.74704 3.96725V3.79831Z"
            fill={color}
        />
        <path
            d="M20.0761 2.8015C19.982 2.73428 19.8559 2.7329 19.7604 2.79806L17.0054 4.67643C16.9301 4.72782 16.885 4.81314 16.885 4.90436V5.20211C16.885 5.42374 17.1331 5.55489 17.3162 5.43003L19.7604 3.76357C19.8559 3.69842 19.982 3.69979 20.0761 3.76702L22.3798 5.41251C22.5624 5.54292 22.816 5.41241 22.816 5.18803V4.90053C22.816 4.81144 22.773 4.72783 22.7005 4.67605L20.0761 2.8015Z"
            fill={color}
        />
        <path
            d="M8.52491 10.5517C8.48943 10.5517 8.45425 10.5585 8.42146 10.572C3.76546 12.4986 1.17612 19.3858 0.903284 22.6787C0.890316 22.8352 1.01604 22.9655 1.17309 22.9655H5.79886C5.96995 22.9655 6.09968 22.8122 6.08003 22.6422C5.67562 19.1447 8.025 13.5758 10.8349 11.341C11.0769 11.1486 10.9238 10.5517 10.6146 10.5517H8.52491Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M14.4537 10.5517C14.4197 10.5517 14.3861 10.5578 14.3544 10.5704C10.2073 12.2165 7.36833 18.659 6.97835 22.6724C6.9629 22.8315 7.08966 22.9655 7.24949 22.9655H11.8718C12.0416 22.9655 12.1709 22.8139 12.1524 22.6452C11.8056 19.483 13.3069 13.6673 16.8325 11.2796C17.0893 11.1057 16.964 10.5517 16.6538 10.5517H14.4537Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M20.5326 10.5517C20.4922 10.5517 20.4521 10.5605 20.4156 10.5779C16.1115 12.6268 13.3958 17.5678 13.3013 22.6895C13.2985 22.8418 13.4223 22.9655 13.5746 22.9655H17.9427C18.1118 22.9655 18.241 22.8153 18.2224 22.6472C17.8572 19.3363 19.3156 13.6565 23.0647 11.2125C23.3191 11.0467 23.2046 10.5517 22.9008 10.5517H20.5326Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M1.85049 10.5517C1.17437 10.5517 0.49825 11.2145 0.342004 11.7604C0.335797 11.7821 0.333252 11.8045 0.333252 11.827V18.9655C0.571983 17.0557 2.56667 13.08 4.97654 11.2397C5.21495 11.0576 5.08237 10.5517 4.78238 10.5517H1.85049Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M23.948 12.4031C24.1242 12.3051 24.3333 12.4375 24.3333 12.6391V21.8234C24.3333 21.849 24.3298 21.8741 24.3218 21.8984C24.2643 22.0729 23.9856 22.821 23.3946 22.9596C23.3769 22.9638 23.3586 22.9655 23.3404 22.9655H19.5057C19.3533 22.9655 19.2295 22.8427 19.2326 22.6904C19.2969 19.4673 20.4883 14.3264 23.948 12.4031Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0767 4.59625C19.9824 4.52813 19.8554 4.52651 19.7594 4.59222L17.4189 6.19364C17.3437 6.24506 17.2988 6.33025 17.2988 6.42131V9.44822C17.2988 9.60057 17.4223 9.72408 17.5746 9.72408H22.1264C22.2787 9.72408 22.4022 9.60057 22.4022 9.44822V6.41686C22.4022 6.32828 22.3597 6.24508 22.2879 6.19322L20.0767 4.59625ZM20.7471 6.82753C20.7471 6.67517 20.6236 6.55167 20.4712 6.55167H19.2298C19.0775 6.55167 18.954 6.67517 18.954 6.82753V8.06891C18.954 8.22126 19.0775 8.34477 19.2298 8.34477H20.4712C20.6236 8.34477 20.7471 8.22126 20.7471 8.06891V6.82753Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M12.6251 2.79027C12.5319 2.72931 12.4112 2.7304 12.3191 2.79304L9.14365 4.95232C9.06812 5.00368 9.02291 5.0891 9.02291 5.18044V9.44822C9.02291 9.60057 9.14641 9.72408 9.29877 9.72408H11.3677C11.5201 9.72408 11.6436 9.60057 11.6436 9.44822V6.82753C11.6436 6.67517 11.7671 6.55167 11.9195 6.55167H13.0229C13.1753 6.55167 13.2988 6.67517 13.2988 6.82753V9.44822C13.2988 9.60057 13.4223 9.72408 13.5746 9.72408H15.7815C15.9339 9.72408 16.0574 9.60057 16.0574 9.44822V5.18365C16.0574 5.09054 16.0104 5.00372 15.9325 4.95276L12.6251 2.79027Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32235 4.59935C5.22593 4.52971 5.09574 4.52971 4.99932 4.59935L2.79243 6.19322C2.72062 6.24508 2.67808 6.32828 2.67808 6.41686V9.44822C2.67808 9.60057 2.80159 9.72408 2.95394 9.72408H7.36773C7.52009 9.72408 7.6436 9.60057 7.6436 9.44822V6.41686C7.6436 6.32828 7.60106 6.24508 7.52925 6.19322L5.32235 4.59935ZM6.12636 6.82753C6.12636 6.67517 6.00285 6.55167 5.85049 6.55167H4.60912C4.45677 6.55167 4.33326 6.67517 4.33326 6.82753V8.06891C4.33326 8.22126 4.45677 8.34477 4.60912 8.34477H5.85049C6.00285 8.34477 6.12636 8.22126 6.12636 8.06891V6.82753Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M2.12636 4.90436C2.12636 4.81314 2.17145 4.72782 2.24681 4.67643L5.00176 2.79806C5.09733 2.7329 5.22339 2.73428 5.31751 2.8015L7.94187 4.67605C8.01437 4.72783 8.05739 4.81144 8.05739 4.90053V5.18803C8.05739 5.41241 7.80377 5.54292 7.62119 5.41251L5.31751 3.76702C5.22339 3.69979 5.09733 3.69842 5.00176 3.76357L2.55762 5.43004C2.3745 5.55489 2.12636 5.42374 2.12636 5.20211V4.90436Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M8.74704 3.79831C8.74704 3.70853 8.79073 3.62437 8.86415 3.57271L12.3153 1.14413C12.4091 1.07811 12.534 1.07705 12.6289 1.14147L16.2123 3.57303C16.2879 3.62437 16.3333 3.70987 16.3333 3.8013V3.97741C16.3333 4.19567 16.0918 4.32748 15.9082 4.20946L12.6231 2.09761C12.5308 2.03829 12.4122 2.03928 12.3209 2.10012L9.17593 4.19678C8.9926 4.319 8.74704 4.18758 8.74704 3.96725V3.79831Z"
            stroke={color}
            strokeWidth="0.275862"
        />
        <path
            d="M20.0761 2.8015C19.982 2.73428 19.8559 2.7329 19.7604 2.79806L17.0054 4.67643C16.9301 4.72782 16.885 4.81314 16.885 4.90436V5.20211C16.885 5.42374 17.1331 5.55489 17.3162 5.43003L19.7604 3.76357C19.8559 3.69842 19.982 3.69979 20.0761 3.76702L22.3798 5.41251C22.5624 5.54292 22.816 5.41241 22.816 5.18803V4.90053C22.816 4.81144 22.773 4.72783 22.7005 4.67605L20.0761 2.8015Z"
            stroke={color}
            strokeWidth="0.275862"
        />
    </svg>
)

const ProfileIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12 13C15.859 13 19 16.14 19 20C19 20.552 18.553 21 18 21H6C5.447 21 5 20.552 5 20C5 16.14 8.141 13 12 13ZM12 3C14.206 3 16 4.794 16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3Z"
            fill="#636363"
        />
        <mask
            id="mask0_18862_127"
            maskUnits="userSpaceOnUse"
            x="5"
            y="3"
            width="14"
            height="18"
        >
            <path
                d="M12 13C15.859 13 19 16.14 19 20C19 20.552 18.553 21 18 21H6C5.447 21 5 20.552 5 20C5 16.14 8.141 13 12 13ZM12 3C14.206 3 16 4.794 16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_18862_127)">
            <rect width="24" height="24" fill="#636363" />
        </g>
    </svg>
)

export const NotificationMessageIcon = ({
    color = '#636363',
    width = '24',
    height = '24'
}: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0063 6L12.5013 10.468C12.1943 10.643 11.8183 10.643 11.5113 10.468L5.00635 6H19.0063ZM19.0063 4H5.00635C3.35235 4 2.00635 5.346 2.00635 7V17C2.00635 18.654 3.35235 20 5.00635 20H19.0063C20.6603 20 22.0063 18.654 22.0063 17V7C22.0063 5.346 20.6603 4 19.0063 4Z"
            fill={color}
        />
    </svg>
)

export const MenuSvgs = {
    HomeIcon,
    VillageIcon,
    VillagesIcon,
    NotificationMessageIcon,
    ProfileIcon
}
